import React from 'react';
import splash from '../assets/images/landing/splash.png';

export default props =>{
    return(
        <div className='landing-img'id="landing">
        <img src={splash} alt="landing imd"/>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/landing_page.js